import { Icon } from "semantic-ui-react";

import "modules/AppointmentDetails/components/Interventions/components/Images/Images.scss";

import type { InterventionAttachment } from "models";

type ImagesProps = {
  data: InterventionAttachment[];
};

export const Images = ({ data = [] }: ImagesProps) => {
  return (
    <div className="Images">
      <div className="image-container">
        {data.map(item => {
          return (
            <div key={item.id} className="image-view">
              <img src={item.url} />
              <div className="image-controls">
                <div className="image-delete">
                  <Icon className="trash grey" />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
